// import React from "react";
// import { Link } from "react-router-dom";
// import ServicesData from "./ServicesData";

// function Services() {
//   return (
//     <div>

//       {/* =====================================================
//           PAGE BANNER
//       ===================================================== */}

//       <section className="page-banner-wrap bg-cover">

//         <div className="container">

//           <div className="row align-items-center">

//             <div className="col-md-12 col-12">

//               <div className="page-heading text-white">

//                 <div className="page-title">
//                   <h1>Services</h1>
//                 </div>

//               </div>

//               <nav aria-label="breadcrumb">

//                 <ol className="breadcrumb">

//                   <li className="breadcrumb-item">
//                     <Link to="/">Home</Link>
//                   </li>

//                   <li
//                     className="breadcrumb-item active"
//                     aria-current="page"
//                   >
//                     Services
//                   </li>

//                 </ol>

//               </nav>

//             </div>

//           </div>

//         </div>

//       </section>


//       {/* =====================================================
//           SERVICES INTRO + MODERN SERVICE CARDS
//       ===================================================== */}

//       <section className="services-modern-wrapper section-padding">

//         <div className="container">

//           {/* SECTION HEADING */}

//           <div className="row text-center mb-50">

//             <div className="col-lg-8 p-lg-0 col-12 offset-lg-2">

//               <div className="section-title">

//                 <p>
//                   HOW CAN WE HELP YOU
//                 </p>

//                 <h1>
//                   We Provide Best IT Solutions
//                   <br />
//                   For Your Business
//                 </h1>

//               </div>

//               <p className="mt-20 services-intro-text">

//                 Software enables companies to streamline their
//                 operations, improve efficiency, and enhance
//                 customer service.

//               </p>

//             </div>

//           </div>


//           {/* =================================================
//               SERVICE CARDS
//           ================================================= */}

//           <div className="row services-modern-grid">

//             {ServicesData.map((service, index) => {

//               const Icon = service.icon;

//               return (

//                 <div
//                   className="col-lg-4 col-md-6 col-12"
//                   key={index}
//                 >

//                   <div className="modern-service-card">


//                     {/* IMAGE */}

//                     <div className="modern-service-image">

//                       <img
//                         src={service.imageUrl}
//                         alt={service.title}
//                       />


//                       {/* DARK IMAGE OVERLAY */}

//                       <div className="modern-service-image-overlay"></div>


//                       {/* NUMBER */}

//                       {/* <div className="modern-service-number">

//                         {String(index + 1).padStart(2, "0")}

//                       </div> */}


//                       {/* ICON */}

//                       <div className="modern-service-icon">

//                         <Icon />

//                       </div>

//                     </div>


//                     {/* CONTENT */}

//                     <div className="modern-service-content">

//                       <h3>
//                         {service.title}
//                       </h3>


//                       <p>
//                         {service.description}
//                       </p>


//                       {/* BOTTOM */}

//                       <div className="modern-service-bottom">

                       

//                         {/* <span className="modern-service-arrow">
//                           →
//                         </span> */}

//                       </div>

//                     </div>

//                   </div>

//                 </div>

//               );

//             })}

//           </div>

//         </div>

//       </section>


//       {/* =====================================================
//           POPULAR IT SERVICES
//       ===================================================== */}

//       <section className="services-wrapper service-1 section-padding section-bg">

//         <div className="container">

//           <div className="row mb-50">

//             <div className="col-12 col-lg-12">

//               <div className="section-title text-white text-center">

//                 <p>
//                   Popular IT services
//                 </p>

//                 <h1>
//                   Our Professional Solutions
//                   <br />
//                   For IT Business
//                 </h1>

//               </div>

//             </div>

//           </div>


//           {/* =================================================
//               POPULAR SERVICE CARDS
//           ================================================= */}

//           <div className="row">


//             {/* CARD 01 */}

//             <div className="col-md-6 col-xl-3 col-12">

//               <div className="single-service-item">

//                 <div className="icon">

//                   <img
//                     src={require("../assets/img/icon/sicon1.png")}
//                     alt="Manage IT Services"
//                   />

//                 </div>

//                 <h4>
//                   Manage IT Services
//                 </h4>

//                 <p>
//                   Managing IT services involves the planning,
//                   implementation, and maintenance of systems.
//                 </p>

//                 <Link to="/services">
//                   Learn More
//                   <i className="fas fa-arrow-right"></i>
//                 </Link>

//               </div>

//             </div>


//             {/* CARD 02 */}

//             <div className="col-md-6 col-xl-3 col-12">

//               <div className="single-service-item">

//                 <div className="icon">

//                   <img
//                     src={require("../assets/img/icon/sicon2.png")}
//                     alt="Product Engineering"
//                   />

//                 </div>

//                 <h4>
//                   Product Engineering
//                 </h4>

//                 <p>
//                   Software product development focused on
//                   designing, developing, and producing solutions.
//                 </p>

//                 <Link to="/services">
//                   Learn More
//                   <i className="fas fa-arrow-right"></i>
//                 </Link>

//               </div>

//             </div>


//             {/* CARD 03 */}

//             <div className="col-md-6 col-xl-3 col-12">

//               <div className="single-service-item">

//                 <div className="icon">

//                   <img
//                     src={require("../assets/img/icon/sicon3.png")}
//                     alt="Web Development"
//                   />

//                 </div>

//                 <h4>
//                   Web Development
//                 </h4>

//                 <p>
//                   We specialize in building custom web
//                   applications tailored to your business needs.
//                 </p>

//                 <Link to="/services">
//                   Learn More
//                   <i className="fas fa-arrow-right"></i>
//                 </Link>

//               </div>

//             </div>


//             {/* CARD 04 */}

//             <div className="col-md-6 col-xl-3 col-12">

//               <div className="single-service-item">

//                 <div className="icon">

//                   <img
//                     src={require("../assets/img/icon/sicon4.png")}
//                     alt="Digital Solutions"
//                   />

//                 </div>

//                 <h4>
//                   Digital Solutions
//                 </h4>

//                 <p>
//                   Technologies, tools, and platforms that enable
//                   developers to build modern web applications.
//                 </p>

//                 <Link to="/services">
//                   Learn More
//                   <i className="fas fa-arrow-right"></i>
//                 </Link>

//               </div>

//             </div>

//           </div>

//         </div>

//       </section>


//       {/* =====================================================
//           CTA
//       ===================================================== */}

//       <section className="cta-banner">

//         <div className="container-fluid bg-cover section-bg">

//           <div className="cta-content">

//             <div className="row align-items-center">


//               {/* CTA TEXT */}

//               <div className="col-xl-7 text-white col-12 text-center text-xl-left">

//                 <h1>

//                   Ready To Get Free Consulations For
//                   <br />
//                   Any Kind Of It Solutions ?

//                 </h1>

//               </div>


//               {/* CTA BUTTONS */}

//               <div className="col-xl-5 col-12 text-center text-xl-right">

//                 <Link
//                   to="/contact"
//                   className="theme-btn mt-4 mt-xl-0"
//                 >

//                   Get a quote

//                   <i className="icon-arrow-right-1"></i>

//                 </Link>


//                 <Link
//                   to="/services"
//                   className="ml-sm-3 mt-4 mt-xl-0 theme-btn minimal-btn"
//                 >

//                   Read More

//                   <i className="icon-arrow-right-1"></i>

//                 </Link>

//               </div>

//             </div>

//           </div>

//         </div>

//       </section>

//     </div>
//   );
// }

// export default Services;


import React from "react";
import { Link } from "react-router-dom";
import ServicesData from "./ServicesData";
import "./Services.css";

function Services() {

  /*
   * ============================================================
   * UPDATE SERVICE CONTENT
   * ============================================================
   *
   * We keep the original images and icons from ServicesData.
   * Only the required service names and descriptions are changed.
   */

  const updatedServices = ServicesData.map((service) => {

    // UI/UX Design → Offshore Development
    if (
      service.title &&
      service.title.toLowerCase().includes("ui/ux")
    ) {
      return {
        ...service,
        title: "Offshore Development",
        description:
          "Extend your technology capabilities with our offshore development services. We provide dedicated development support, scalable engineering resources, and cost-effective software solutions for businesses across global markets."
      };
    }

    // AI in Web → AI Solutions
    if (
      service.title &&
      service.title.toLowerCase().includes("ai in web")
    ) {
      return {
        ...service,
        title: "AI Solutions",
        description:
          "Transform your business with intelligent AI solutions designed to automate processes, improve decision-making, enhance customer experiences, and bring smarter capabilities to your digital platforms."
      };
    }

    // Keep everything else exactly as it is.
    return service;
  });


  return (
    <div className="dnk-services-page">

      {/* =====================================================
          PAGE BANNER
      ===================================================== */}

      {/* =====================================================
    SERVICES PAGE BANNER
===================================================== */}

<section className="dnk-services-page-banner">

  {/* Very subtle decorative shapes */}
  <span className="dnk-services-banner-shape dnk-services-shape-one"></span>
  <span className="dnk-services-banner-shape dnk-services-shape-two"></span>

  <div className="container">

    <div className="dnk-services-banner-content">

      {/* Small gold label */}

      <div className="dnk-services-banner-label">
        <span></span>
        DNK SOFTWARE SERVICES
        <span></span>
      </div>


      {/* Heading */}

      <h1>
        Services
      </h1>


      {/* Gold underline */}

      <div className="dnk-services-banner-underline"></div>


      {/* Description */}

      <p>
        We deliver reliable technology solutions that help businesses
        innovate, scale and grow.
      </p>


      {/* Breadcrumb */}

      <nav
        className="dnk-services-breadcrumb"
        aria-label="breadcrumb"
      >

        <Link to="/">
          Home
        </Link>

        <span>→</span>

        <strong>
          Services
        </strong>

      </nav>

    </div>

  </div>

</section>


      {/* =====================================================
          MAIN SERVICES SECTION
      ===================================================== */}

      <section className="services-modern-wrapper section-padding">

        <div className="container">

          {/* =================================================
              SECTION HEADING
          ================================================= */}

          <div className="row text-center dnk-services-heading">

            <div className="col-lg-8 col-12 offset-lg-2">

              <div className="section-title">

                <p>
                  HOW CAN WE HELP YOU
                </p>

                <h1>
                  We Provide Best IT Solutions
                  <br />
                  For Your Business
                </h1>

              </div>

              <p className="services-intro-text">
                Software enables companies to streamline their
                operations, improve efficiency, and enhance
                customer service. At DNK Software, we combine
                technology, engineering and innovation to deliver
                practical digital solutions for modern businesses.
              </p>

            </div>

          </div>


          {/* =================================================
              MAIN SERVICE CARDS
          ================================================= */}

          <div className="row services-modern-grid">

            {updatedServices.map((service, index) => {

              const Icon = service.icon;

              return (

                <div
                  className="col-lg-4 col-md-6 col-12 dnk-service-column"
                  key={service.title || index}
                >

                  <div
                    className={
                      index === 0
                        ? "modern-service-card modern-service-card-featured"
                        : "modern-service-card"
                    }
                  >

                    {/* =====================================
                        SERVICE IMAGE
                    ===================================== */}

                    <div className="modern-service-image">

                      <img
                        src={service.imageUrl}
                        alt={service.title}
                      />


                      {/* Image overlay */}

                      <div className="modern-service-image-overlay"></div>


                      {/* =================================
                          FIRST SERVICE BADGE
                      ================================= */}

                      {index === 0 && (
                        <div className="dnk-featured-service-badge">
                          <span></span>
                          Featured
                        </div>
                      )}


                      {/* =================================
                          SERVICE ICON
                      ================================= */}

                      {Icon && (
                        <div className="modern-service-icon">
                          <Icon />
                        </div>
                      )}

                    </div>


                    {/* =====================================
                        SERVICE CONTENT
                    ===================================== */}

                    <div className="modern-service-content">

                      {/* Number */}

                      <div className="dnk-service-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>


                      {/* Title */}

                      <h3>
                        {service.title}
                      </h3>


                      {/* Description */}

                      <p>
                        {service.description}
                      </p>


                      {/* Bottom decorative line */}

                      <div className="modern-service-bottom">
                        <span className="dnk-service-line"></span>
                      </div>

                    </div>

                  </div>

                </div>

              );
            })}

          </div>

        </div>

      </section>


      {/* =====================================================
          POPULAR IT SERVICES
      ===================================================== */}

      <section className="services-wrapper service-1 section-padding section-bg">

        <div className="container">

          {/* Section heading */}

          <div className="row mb-50">

            <div className="col-12">

              <div className="section-title text-white text-center">

                <p>
                  Popular IT Services
                </p>

                <h1>
                  Our Professional Solutions
                  <br />
                  For IT Business
                </h1>

              </div>

            </div>

          </div>


          {/* =================================================
              POPULAR SERVICE CARDS
          ================================================= */}

          <div className="row">


            {/* ================================================
                CARD 01
            ================================================= */}

            <div className="col-md-6 col-xl-3 col-12">

              <div className="single-service-item">

                <div className="icon">

                  <img
                    src={require("../assets/img/icon/sicon1.png")}
                    alt="Manage IT Services"
                  />

                </div>

                <h4>
                  Manage IT Services
                </h4>

                <p>
                  Managing IT services involves the planning,
                  implementation, and maintenance of systems.
                </p>

                <Link to="/services">
                  Learn More
                  <i className="fas fa-arrow-right"></i>
                </Link>

              </div>

            </div>


            {/* ================================================
                CARD 02
            ================================================= */}

            <div className="col-md-6 col-xl-3 col-12">

              <div className="single-service-item">

                <div className="icon">

                  <img
                    src={require("../assets/img/icon/sicon2.png")}
                    alt="Product Engineering"
                  />

                </div>

                <h4>
                  Product Engineering
                </h4>

                <p>
                  Software product development focused on
                  designing, developing, and producing solutions.
                </p>

                <Link to="/services">
                  Learn More
                  <i className="fas fa-arrow-right"></i>
                </Link>

              </div>

            </div>


            {/* ================================================
                CARD 03
            ================================================= */}

            <div className="col-md-6 col-xl-3 col-12">

              <div className="single-service-item">

                <div className="icon">

                  <img
                    src={require("../assets/img/icon/sicon3.png")}
                    alt="Web Development"
                  />

                </div>

                <h4>
                  Web Development
                </h4>

                <p>
                  We specialize in building custom web
                  applications tailored to your business needs.
                </p>

                <Link to="/services">
                  Learn More
                  <i className="fas fa-arrow-right"></i>
                </Link>

              </div>

            </div>


            {/* ================================================
                CARD 04
            ================================================= */}

            <div className="col-md-6 col-xl-3 col-12">

              <div className="single-service-item">

                <div className="icon">

                  <img
                    src={require("../assets/img/icon/sicon4.png")}
                    alt="Digital Solutions"
                  />

                </div>

                <h4>
                  Digital Solutions
                </h4>

                <p>
                  Technologies, tools, and platforms that enable
                  developers to build modern web applications.
                </p>

                <Link to="/services">
                  Learn More
                  <i className="fas fa-arrow-right"></i>
                </Link>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          CTA SECTION
      ===================================================== */}

      <section className="cta-banner">

        <div className="container-fluid bg-cover section-bg">

          <div className="cta-content">

            <div className="row align-items-center">


              {/* CTA TEXT */}

              <div className="col-xl-7 text-white col-12 text-center text-xl-left">

                <h1>
                  Ready To Get Free Consulations For
                  <br />
                  Any Kind Of It Solutions ?
                </h1>

              </div>


              {/* CTA BUTTONS */}

              <div className="col-xl-5 col-12 text-center text-xl-right">

                <Link
                  to="/contact"
                  className="theme-btn mt-4 mt-xl-0"
                >
                  Get a quote
                  <i className="icon-arrow-right-1"></i>
                </Link>


                <Link
                  to="/services"
                  className="ml-sm-3 mt-4 mt-xl-0 theme-btn minimal-btn"
                >
                  Read More
                  <i className="icon-arrow-right-1"></i>
                </Link>

              </div>

            </div>

          </div>

        </div>

      </section>

    </div>
  );
}

export default Services;